import { EnquiryStatus } from "../../enums/enquiryStatus";
import { EnquiryType } from "../../enums/enquiryType";

class CreateEnquiryDto {
    public enquiryTitle: string;
    public firstName: string;
    public lastName: string;
    public companyName: string;
    public IsTrading: boolean;
    public companyAddress1: string;
    public companyAddress2: string;
    public companyAddress3: string;
    public companyCity: string;
    public companyCounty: string;
    public companyPostcode: string;
    public emailAddress: string;
    public phoneNumber: string;
    public message: string;
    public parentId: string;
    public url : string;
    public referer: string;
    public privacy: boolean;
    public partnerId: string;
    public partnerEnquiryId: string;
    public productId: string;
    public productName: string;
    public status: EnquiryStatus;
    public type: EnquiryType;
    public source: string;
    public queueId: string;
    public emailTemplateId: string;
    public fromAddress: string;
    public fromName: string;
}

export { CreateEnquiryDto };